var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-title":".dot-collision"}},[_c('div',{staticClass:"stage"},[_c('div',{staticClass:"dot-collision"})])])}]

export { render, staticRenderFns }